<template>
  <img :src="accountImage(this.role)" :alt="this.role">
</template>

<script>
import config from '@/config.js'

export default {
  name: 'AccountImage',
  props: ['role'],
  methods: {
    accountImage (role) {
      switch (role) {
        case config.role.Root:
          return require('../assets/images/user-aplix.png')
        case config.role.Administrator:
          return require('../assets/images/user-default03.png')
        case config.role.Manager:
          return require('../assets/images/user-default02.png')
        case config.role.Staff:
          return require('../assets/images/user-default01.png')
        default:
          return require('../assets/images/user-default01.png')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProfileImage.vue?0548a59b